/**
 * Display name for the falling-block game (internal key/env id: 'tetris').
 * PROVISIONAL — placeholder pending final naming decision; renaming is a
 * one-line change here. Internal ids, routes and SDK names do not use it.
 */
export const STACKFALL_DISPLAY_NAME = 'Stack Rise';
